import { bulkUpdateClients, bulkDeleteClients } from '@/shared/api/bulk';
import { downloadCsv } from '@/shared/utils/download';
import { CLIENT_STATUS_BADGE as STATUS_CONFIG } from '@/shared/constants/statuses';

/**
 * Actions de masse des clients, au format `shared/components/BulkEditDialog`.
 *
 * Fabrique plutôt que constante : la liste des installateurs vient de l'API, elle ne
 * peut pas être figée au chargement du module.
 *
 * @param {Array} installateurs comptes de rôle installateur, tels que renvoyés par /users
 */
// `agregateurs` vient de `useAgregateurs`, LU EN BASE — huitième et dernier endroit où
// les trois valeurs étaient écrites à la main. Ici le défaut coûtait plus cher
// qu'ailleurs : `default_value: 'Survoltage'` faisait qu'une action en masse lancée
// sans toucher au menu attribuait Survoltage à toute une sélection de clients.
export default function clientBulkActions(installateurs = [], agregateurs = []) {
  const optionsAgregateur = [
    ...agregateurs.map((a) => ({ value: a.name, label: a.name })),
    { value: 'Autre', label: 'Autre' },
  ];
  return {
    aggregateur: {
      label: 'Attribuer un agrégateur',
      family: 'select',
      value_label: 'Agrégateur',
      // Pas de défaut : le premier de la liste serait choisi sans que personne l'ait
      // voulu, sur une action qui redirige le pilotage de tout un lot de clients.
      default_value: '',
      options: optionsAgregateur,
      warning: "L'agrégateur détermine qui pilote les actifs du client. Le changer "
        + 'redirige les futures activations.',
      run: (ids, aggregateur) => bulkUpdateClients(ids, { aggregateur }),
    },
    statut: {
      label: 'Changer le statut',
      family: 'select',
      value_label: 'Nouveau statut',
      default_value: 'actif',
      options: ['prospect', 'mandat_envoye', 'signe', 'actif', 'resilie'].map(s => ({
        value: s, label: STATUS_CONFIG[s]?.label || s,
      })),
      warning: 'Le statut pilote le suivi commercial et la visibilité du client dans les '
        + 'tableaux de bord.',
      run: (ids, statut) => bulkUpdateClients(ids, { statut }),
    },
    installateur: {
      label: "Réassigner l'installateur",
      family: 'select',
      value_label: 'Installateur',
      value_placeholder: 'Choisir un installateur',
      options: installateurs.map(i => ({ value: i.id, label: i.name })),
      warning: "L'ancien installateur perd l'accès aux dossiers réassignés, le nouveau "
        + 'les voit immédiatement.',
      run: (ids, installateurId) => bulkUpdateClients(ids, {}, installateurId),
    },
    export: {
      label: 'Exporter en CSV',
      family: 'action',
      warning: "Télécharge les fiches sélectionnées sur votre poste. Le fichier contient "
        + 'des données personnelles : ne le diffusez pas hors du cadre du mandat.',
      run: async (ids) => {
        await downloadCsv(`/export/clients/csv?ids=${ids.join(',')}`);
        return { total: ids.length, ok: ids.length, failed: [] };
      },
    },
    delete: {
      label: 'Supprimer les clients',
      family: 'action',
      tone: 'danger',
      alwaysReport: true,
      warning: 'Suppression définitive. Les actifs et les mandats rattachés sont supprimés '
        + "avec les clients, sans restauration possible depuis l'interface.",
      run: ids => bulkDeleteClients(ids),
    },
  };
}
